import { supportStatusLabelToId } from "./supportConstants";

export type SlaState =
  | "onTrack"
  | "approaching"
  | "met"
  | "breachedOpen"
  | "breachedResolved"
  | "paused";
export type SlaAction = "RUNNING" | "PAUSED" | "STOPPED";

const RESOLUTION_ACTION_BY_LABEL: Record<string, SlaAction> = {
  Open: "RUNNING",
  "Under investigation": "RUNNING",
  Accepted: "RUNNING",
  "In Progress": "RUNNING",
  Developed: "RUNNING",
  Released: "PAUSED",
  Canceled: "PAUSED",
  "Waiting for customer": "PAUSED",
  Closed: "STOPPED",
};

export const SLA_RESOLUTION_ACTION: Record<string, SlaAction> =
  Object.fromEntries(
    Object.entries(RESOLUTION_ACTION_BY_LABEL)
      .map(([label, action]) => [supportStatusLabelToId[label], action] as const)
      .filter(([id]) => Boolean(id)),
  );

export function resolutionAction(statusId: string): SlaAction {
  return SLA_RESOLUTION_ACTION[statusId] ?? "RUNNING";
}

const MINUTE_MS = 60_000;
const SLA_HOUR_MS = 60 * MINUTE_MS;

export interface SeverityTargets {
  responseMs: number;
  resolutionMs: number;
}

export const SEVERITY_SLA_TARGETS: Record<string, SeverityTargets> = {
  "1": { responseMs: 30 * MINUTE_MS, resolutionMs: 4 * SLA_HOUR_MS },
  "2": { responseMs: 30 * MINUTE_MS, resolutionMs: 12 * SLA_HOUR_MS },
  "3": { responseMs: 30 * MINUTE_MS, resolutionMs: 48 * SLA_HOUR_MS },
};

export const DEFAULT_SEVERITY_ID = "3";

export function targetsForSeverity(
  severityId?: string | null,
): SeverityTargets {
  return (
    SEVERITY_SLA_TARGETS[severityId ?? ""] ??
    SEVERITY_SLA_TARGETS[DEFAULT_SEVERITY_ID]!
  );
}

export const SEVERITY_SLA_COMPLIANCE_PCT: Record<string, number> = {
  response: 95,
  "1": 99,
  "2": 95,
  "3": 95,
};

export interface PriorityTargets {
  responseBh: number;
  resolutionBh: number;
}

export const SLA_TARGETS: Record<string, PriorityTargets> = {
  "1": { responseBh: 4, resolutionBh: 9 }, // P1 · 1 business day
  "2": { responseBh: 8, resolutionBh: 45 }, // P2 · 5 business days
  "3": { responseBh: 24, resolutionBh: 135 }, // P3 · 15 business days
  "4": { responseBh: 24, resolutionBh: 270 }, // P4 · 30 business days
};

export const DEFAULT_PRIORITY_ID = "1";

export function targetsForPriority(
  priorityId?: string | null,
  targets: Record<string, PriorityTargets> = SLA_TARGETS,
): PriorityTargets {
  return (
    targets[priorityId ?? ""] ??
    targets[DEFAULT_PRIORITY_ID] ??
    SLA_TARGETS[DEFAULT_PRIORITY_ID]!
  );
}
